<div class="savvy-card"
	 [class.savvy-card--selected]="selected"
	 [class.savvy-card--hoverable]="hoverable">
	<ng-content></ng-content>
</div>
